module.exports = __webpack_public_path__ + "img/53-white.e1b61972.svg";